import {
  React,
  Component,
  withCookies,
  helpers,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  Chat,
  PostulationForm,
  SignButtonComponent,
} from 'imports/ComponentsImports';

import {
  ModalWithChildren,
  LoadingDialog,
  AlertDialog,
  AlertDialogOneButton,
  IconWithTooltip,
  FailureColor,
} from 'imports/DesignImports';

import {
  DoneIcon,
  ExpandMoreIcon,
  FullCircleIcon,
  EmptyCircleIcon,
  ViewIcon,
  EditIcon,
  DeleteIcon,
  CancelIcon,
} from 'imports/IconsImports';

import {
  IconButton,
  List,
  Paper,
} from 'material-ui';

const styles = {
  list: {
    padding: '0px'
  },
  listHeader: {
    backgroundColor: '#F0F0EF',
    padding: '10px 0px 10px 15px',
  },
  listHeaderContainer: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Lato',
  },
  listItem: {
    borderBottom: '2px #F0F0EF solid',
    backgroundColor: '#fbfbfb',
    padding: '3px 0px 3px 15px',
    cursor: 'pointer',
  },
  listItemContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    fontFamily: 'Lato'
  },
  emptyListItemContainer: {
    display: 'flex',
    fontFamily: 'Lato',
    justifyContent: 'center',
    padding: '1em'
  },
  flex1:{
    flex: '1'
  },
  flex2:{
    flex: '2'
  },
  flexFullCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  viewButton: {
    border: '2px #212F55 solid',
    fontFamily: 'Lato'
  },
}

class ProjectList extends Component {
  constructor(props){
    super(props)
    this.state = {
      reverseSort: {
        name: false,
        area: false,
        leader: false,
        progress: false,
        state: false
      },
      projects: this.props.projects || [],
      doneProjects: this.props.doneProjects || [],
      loadingDialog: false,
      alertDialog: false,
      alertMessage: '',
      alertDialogOneButton: false,
      signDialog: false,
      postulationForm: false,
      token:this.props.cookies.get('token'),
      user: this.props.cookies.get('user'),
    }
  }

  componentDidMount() {
    if(!this.props.projects)
      this.getProjects();
  }

  componentWillReceiveProps(props) {
    if(props.projects){
      this.setState({
        projects: props.projects,
      });
    }
  }

  render() {

    return(
      <List style={styles.list}>
      <Paper zDepth={1} style={{marginBottom: '10px'}}>
        <div
        style={styles.listHeader}
        >
        <div style={styles.listHeaderContainer}>
          {this.getHeaders()}
        </div>
      </div>
        </Paper>
        <Paper zDepth={1}>
        {this.state.projects.length > 0 || this.state.doneProjects.length > 0 ?
          [this.state.projects.map((project, i) => {
          return (<div
              key={project.id}
              hovercolor='#9e9e9e'
              style={styles.listItem}
              onClick={this.getListClick(project, i)}
            >
            <div style={styles.listItemContainer}>
              {this.getContent(project)}
            </div>
          </div>)
        }),
          this.state.doneProjects.map((project, i) => {
          return (<div
              key={project.id}
              hovercolor='#9e9e9e'
              style={styles.listItem}
            >
            <div style={styles.listItemContainer}>
              <DoneIcon />
              {this.getContent(project)}
            </div>
          </div>)
        })] :
          <div
            style={styles.listItem}
          >
          <div style={styles.emptyListItemContainer}>
            No hay proyectos para mostrar
          </div>
        </div>
        }
        </Paper>
        { this.state.postulationForm ? <ModalWithChildren project={this.state.project} children={<PostulationForm project={this.state.project} currency={this.state.user.company_currency}/>} cancel={() => this.setState({project: null, postulationForm: false})} confirm={(project) => this.patchProject(project, this.state.position)}/> : null}
        { this.state.loadingDialog ? <LoadingDialog message="Estamos enviando los datos, espera un momento" /> : null }
        { this.state.alertDialog ?
          <AlertDialog
            title={this.state.alertTitle}
            message={this.state.alertMessage}
            acceptLabel={this.state.acceptLabel}
            cancelLabel={this.state.cancelLabel}
            confirm={this.state.confirm}
            cancel={() => this.setState({alertDialog: false})}/> : null}
        { this.state.alertDialogOneButton ?
          <AlertDialogOneButton
            title={this.state.alertTitle}
            message={this.state.alertMessage}
            acceptLabel={this.state.acceptLabel}
            confirm={this.state.confirm}/> : null}
        </List>
      )
    }

    orderProjectsBy = (type) => {
      var reverseSort = this.state.reverseSort;
      var projects = this.state.projects;
      var temp = reverseSort[type];
      for (var key in reverseSort) {
        if (reverseSort.hasOwnProperty(key)) {
          reverseSort[key] = false;
        }
      }
      reverseSort[type] = !temp;
      reverseSort[type] ? projects.sort(helpers.comparers.reverse[type]) : projects.sort(helpers.comparers[type]);
      this.setState({
        projects: projects,
        reverseSort: reverseSort
      })
    }

    getHeaders = () => {
      let headers = [];
      this.props.shownData.forEach((type, i) => {
        switch (type) {
          case 'name':
            headers.push(
              <div key={i} style={{...styles.flex2, ...{alignItems: 'center', display: 'flex'}}}>
                <div style={{marginRight:'20px'}}>Nombre del Proyecto </div>
                <IconButton style={{padding: '0px', height: '24px', width: '24px'}} onClick={() => this.orderProjectsBy('name', false)} > <ExpandMoreIcon/></IconButton>
              </div>
            );
            break;
          case 'area':
            headers.push(
              <div key={i} style={{...styles.flex1, ...{alignItems: 'center', display: 'flex'}}}>
                <div style={{marginRight:'20px'}}>Área </div>
                <IconButton style={{padding: '0px', height: '24px', width: '24px'}} onClick={() => this.orderProjectsBy('area', false)} > <ExpandMoreIcon/></IconButton>
              </div>
            );
            break;
          case 'leader':
            headers.push(
              <div key={i} style={{...styles.flex2, ...{alignItems: 'center', display: 'flex'}}}>
                <div style={{marginRight:'20px'}}>Líder </div>
                <IconButton style={{padding: '0px', height: '24px', width: '24px'}} onClick={() => this.orderProjectsBy('leader', false)} > <ExpandMoreIcon/></IconButton>
              </div>
            );
            break;
          case 'implement_date':
            headers.push(
              <div key={i} style={{...styles.flex2, ...{alignItems: 'center', display: 'flex'}}}>
                <div style={{marginRight:'20px'}}>Fecha de implementación </div>
                <IconButton style={{padding: '0px', height: '24px', width: '24px'}} onClick={() => this.orderProjectsBy('implementDate', false)} > <ExpandMoreIcon/></IconButton>
              </div>
            );
            break;
          case 'remaining_years':
            headers.push(
              <div key={i} style={{...styles.flex2, ...{alignItems: 'center', display: 'flex'}}}>
                <div style={{marginRight:'20px'}}>Años restantes </div>
                <IconButton style={{padding: '0px', height: '24px', width: '24px'}} onClick={() => this.orderProjectsBy('remainingYears', false)} > <ExpandMoreIcon/></IconButton>
              </div>
            );
            break;
          case 'years':
            headers.push(
              <div key={i} style={{...styles.flex2, ...{alignItems: 'center', display: 'flex'}}}>
                <div style={{marginRight:'20px'}}>Antiguedad</div>
                <IconButton style={{padding: '0px', height: '24px', width: '24px'}} onClick={() => this.orderProjectsBy('Years', false)} > <ExpandMoreIcon/></IconButton>
              </div>
            );
            break;
          case 'progress':
            headers.push(
              <div key={i} style={{...styles.flex1, ...{alignItems: 'center', display: 'flex'}}}>
                  <div style={{marginRight:'20px'}}>Avance </div>
                  <IconButton style={{padding: '0px', height: '24px', width: '24px'}} onClick={() => this.orderProjectsBy('progress', false)} > <ExpandMoreIcon/></IconButton>
                </div>
            );
            break;
          case 'state':
            headers.push(
              <div key={i} style={{...styles.flex1, ...{alignItems: 'center', display: 'flex'}}}>
                <div style={{marginRight:'20px'}}>Estado </div>
                <IconButton style={{padding: '0px', height: '24px', width: '24px'}} onClick={() => this.orderProjectsBy('state', false)} > <ExpandMoreIcon/></IconButton>
              </div>
            );
            break;
          case 'economic_impact':
            headers.push(
              <div key={i} style={{...styles.flex1, ...{alignItems: 'center', display: 'flex'}}}>
                <div style={styles.listHeader}>Impacto ({this.state.user.company_currency}) </div>
                <IconButton style={{padding: '0px', height: '24px', width: '24px'}} onClick={() => this.orderProjectsBy('economicImpact')} > <ExpandMoreIcon/></IconButton>
              </div>
            );
            break;
          case 'implementation_date':
            headers.push(
              <div key={i} style={{...styles.flex1, ...{alignItems: 'center', display: 'flex'}}}>
                <div style={styles.listHeader}>Implementación </div>
                <IconButton style={{padding: '0px', height: '24px', width: '24px'}} onClick={() => this.orderProjectsBy('year')} > <ExpandMoreIcon/></IconButton>
              </div>
            );
            break;
          case 'edit_and_delete':
            headers.push(
              <div key={i} style={{...styles.flex1, ...styles.flexFullCenter}}>Acción</div>
            );
            break;
          case 'edit':
            headers.push(
              <div key={i} style={{...styles.flex1, ...styles.flexFullCenter}}>Acción</div>
            );
            break;
          case 'sign':
            headers.push(
              <div key={i} style={{...styles.flex1, ...styles.flexFullCenter}}>Acción</div>
            );
            break;
          case 'comments':
          headers.push(
            <div key={i} style={{...styles.flex1, ...styles.flexFullCenter}}>Comentarios</div>
          );
          break;
          default:
            break;
        }
      })
      return headers;
    }

    getContent = (project) => {
      let content = [];
      this.props.shownData.forEach((type, i) => {
        switch (type) {
          case 'name': content.push(
            <div key={project.id + ',' + i} style={styles.flex2}>{project.information.name.length >= 25 ? project.information.name.substring(0, 22) + '...' : project.information.name}</div>
          );
          break;
          case 'area': content.push(
            <div key={project.id + ',' + i} style={styles.flex1}>{project.information.area.name}</div>
          );
          break;
          case 'leader': content.push(
            <div key={project.id + ',' + i} style={styles.flex2}>
              {(project.information.leader_first_name + ' ' + project.information.leader_last_name).length >= 30 ?
                (project.information.leader_first_name + ' ' + project.information.leader_last_name).substring(0, 27) + '...' :
                (project.information.leader_first_name + ' ' + project.information.leader_last_name)}
              </div>
            );
          break;
          case 'progress': content.push(
            <div key={project.id + ',' + i} style={styles.flex1}>
              {this.getProjectProgress(project)}
            </div>
          );
          break;
          case 'implement_date': content.push(
            <div key={project.id + ',' + i} style={{...styles.flex1, ...{textAlign: 'center'}}}>{(new Date(project.information.start_date)).getFullYear()}</div>
          );
          break;
          case 'remaining_years':
          let remainingYears = (new Date(project.information.end_date)).getFullYear()-(new Date(Date.now())).getFullYear()
          content.push(
            <div key={project.id + ',' + i} style={{...styles.flex1, ...{textAlign: 'center'}}}>{remainingYears >= 0 ? remainingYears : 0}</div>
          );
          break;
          case 'years':
          let Years = (new Date(Date.now())).getFullYear()-(new Date(project.information.start_date)).getFullYear()
          content.push(
            <div key={project.id + ',' + i} style={{...styles.flex1, ...{textAlign: 'center'}}}>{Years === 1 ? Years + " año" : Years + " años"}</div>
          );
          break;
          case 'state': content.push(
            <div key={project.id + ',' + i} style={styles.flex1}>{project.state.length > 0 ? project.state[0].state : ""}</div>
          );
          break;
          case 'economic_impact': content.push(
            <div key={project.id + ',' + i} style={{...styles.flex1, ...{textAlign: 'left'}}}>{helpers.numberWithDots(project.information.economic_impact)}</div>
          );
          break;
          case 'implementation_date': content.push(
            <div key={project.id + ',' + i} style={{...styles.flex1, ...{textAlign: 'right', paddingRight: '2em'}}}>{project.information.start_date.split('-')[0]}</div>
          );
          break;
          case 'sign': content.push(
            <div key={project.id + ',' + i} style={{...styles.flex1, ...styles.flexFullCenter}}>
              <SignButtonComponent token={this.state.token} project={project} user={this.state.user}/>
            </div>
          );
          break;
          case 'edit': content.push(
            <div key={project.id + ',' + i} style={{...styles.flex1, ...styles.flexFullCenter}}>
              <IconButton tooltip="Editar"
                style={styles.iconButton}
                onClick={(event) => {event.stopPropagation(); 
                  this.props.history.push({pathname: `/project/${project.id}/edit`, state: {project: project}})}
                }
              >
                <EditIcon />
              </IconButton>
              <IconButton tooltip="Eliminar"
                style={styles.iconButton}
                onClick={(event) => { event.stopPropagation(); this.raiseAlert('¡Atención', '¿Estás seguro que quieres eliminar la postulación?', 'Sí, eliminar', 'No, volver', () => this.deletePostulation(project, i)) }}
                >
                <DeleteIcon />
              </IconButton>
            </div>
          );
          break;
          case 'edit_and_delete': content.push(
            <div key={project.id + ',' + i} style={{...styles.flex1, ...styles.flexFullCenter}}>
              <IconButton tooltip="Ver"
                style={styles.iconButton}
                onClick={(event) => {event.stopPropagation(); this.setState({postulationForm: true, project: project, position: i})}}

                >
                <ViewIcon />
              </IconButton>
              <IconButton tooltip="Eliminar"
                style={styles.iconButton}
                onClick={(event) => { event.stopPropagation(); this.raiseAlert('¡Atención', '¿Estás seguro que quieres eliminar la postulación?', 'Sí, eliminar', 'No, volver', () => this.deletePostulation(project, i)) }}
                >
                <DeleteIcon />
              </IconButton>
            </div>
          );
          break;
          case 'comments': content.push(
            <Chat key={project.id + ',' + i} project={project} type='selection'/>
          );
          break;
          default:
            break;
        }
      })
      return content;
    }

    patchProject = (project, i) => {
      this.setState({loadingDialog: true})
      var connection = axios.create({
        baseURL: routes.host,
        headers: {'Authorization': "Token "+ this.state.token}
      });
      connection.patch(routes.patchProjectPostulation(project.id), project)
      .then((response) => {
        this.raiseOneButtonAlert('¡Felicitaciones!', 'Has modificado la postulación del proyecto', 'Aceptar', () => window.location.reload());
      })
      .catch((error) => {
        console.log(error);
        this.raiseOneButtonAlert('¡Error!', 'Hubo un error al modificar el proyecto', 'Aceptar', () => this.setState({alertDialogOneButton: false}));
        this.setState({
          loadingDialog: false,
          postulationForm: false,
          project: null
        })
      });
    }

    deletePostulation = (project, i) => {
      this.setState({loadingDialog: true})
      var connection = axios.create({
        baseURL: routes.host,
        headers: {'Authorization': "Token "+ this.state.token}
      });
      connection.delete(routes.deleteProjectPostulation(this.state.user.company_id, null, project.id))
      .then((response) => {
        this.raiseOneButtonAlert('¡Atención!', 'Has eliminado el proyecto', 'Aceptar', () => this.setState({alertDialogOneButton: false}, window.location.reload()))
        var newState = this.state;
        newState.projects.splice(i, 1);
        this.setState(newState);
        this.setState({loadingDialog: false});
      })
      .catch((error) => {
        console.log(error);
        this.raiseOneButtonAlert('¡Error!', 'Hubo un error al eliminar el proyecto', 'Aceptar', () => this.setState({alertDialogOneButton: false}))
        this.setState({
          loadingDialog: false,
          alertDialog: false,
        })
      });
    }

    sign = (decision, justification) => {
      this.setState({loadingDialog: true})
      var connection = axios.create({
        baseURL: routes.host,
        headers: {'Authorization': "Token "+ this.state.token}
      });
      let data = {
        decision: decision,
        justification: justification,
      }
      connection.post(routes.signProject(this.state.project.id), data)
      .then((response) => {
        this.raiseOneButtonAlert('¡Felicidades!', 'Tu decisión sobre el proyecto ha sido enviada', 'Aceptar', () => this.setState({alertDialog: false}))
        this.setState({project: null, loadingDialog: false});
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
        this.raiseOneButtonAlert('¡Atención!', 'Hubo un problema al enviar tu decisión, por favor intenta nuevamente', 'Aceptar', () => this.setState({alertDialog: false}))
        this.setState({project: null, loadingDialog: false});
      });
    }

    getProjectProgress = (project) => {
      let milestonesComponent = []
      if(project.state.map(state => state.state).includes('No trazable')){
          milestonesComponent = (
            <div style={{display: 'flex', alignItems: 'center'}}>
              <CancelIcon color={FailureColor} style={{marginRight: '0.5em'}}/>
              <div>No trazable</div>
            </div>
          )
      }
      else{
        project.milestones.forEach((milestone, i) => {
          milestonesComponent.push(
            <IconWithTooltip
              key={i}
              tooltip={milestone.milestone.name}
              icon={
                milestone.completed ?
                <FullCircleIcon/> :
                <EmptyCircleIcon/>
              }/>
          )
        })
      }
      return milestonesComponent;
    }

    getListClick = (project, i) => {
      if(this.props.shownData.includes('edit'))
        return (() => {
          this.props.history.push({
            pathname: `/project/${project.id}/edit`,
            state: {project: project}
        })
        });
      if(this.props.shownData.includes('view'))
        return (() => {
          this.props.history.push({
            pathname: '/project/' + project.id,
            state: {project: project}
        })
        });
      else if (this.props.shownData.includes('edit_and_delete')) {
        return ((event) => {
          event.stopPropagation();
          this.setState({postulationForm: true, project: project, position: i})
        });
      }
      return null;
    }

    raiseAlert = (title, message, acceptLabel, cancelLabel, confirm) => {
      this.setState({alertDialog: true, alertTitle: title, alertMessage: message, acceptLabel: acceptLabel, cancelLabel: cancelLabel, confirm: confirm, cancel: () => this.setState({alertDialog: false})})
    }

    raiseOneButtonAlert = (title, message, acceptLabel, confirm) => {
      this.setState({alertDialogOneButton: true, alertTitle: title, alertMessage: message, acceptLabel: acceptLabel, confirm: confirm})
    }
  }

export default withCookies(ProjectList);



// WEBPACK FOOTER //
// ./src/components/files/ProjectList.js